export const getHost = function () {
  const l = window.location;
  return 'https://' + l.hostname + (l.port ? ':' + l.port : '');
};
